/** Trigger a browser download for a locally generated blob. */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  anchor.click()
  // Deferred revoke: immediate revocation can abort the download in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

/** Last path segment of a file name (safe for use as a download name). */
export function basename(name: string): string {
  return name.split('/').pop() ?? name
}
